import { Row, Col } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

const UserGuide = props => {

  return (
    <>
    <Row>
      <Col xs={12}>
        <h1>User Guide</h1>
        <hr />
      </Col>

      {/* Settings Section */}
      <Col xs={12} className="mb-4">
        <div className="p-3 rounded bg-white text-dark">
          <h3>Settings & Account</h3>
          <p>Access the settings via the <strong>Cog Icon (<Icon.Gear />)</strong> in the top-left corner.</p>
          <ul>
            <li><p><strong>Login (Optional):</strong> Registering allows you to save your data to the cloud and access it from 
            any device.</p>
            <p><strong>Note:</strong> If you are not logged in, your data is stored locally and may be lost if you clear your browser 
            cache.</p></li>
            <li><strong>Profiles:</strong> You can manage up to 4 financial profiles. Use this to track different scenarios or 
            household members.</li>
            <li><strong>Calculation Logic:</strong> Choose between:
              <ul>
                <li><strong>Standard (4 Weeks):</strong> Simple "4 weeks = 1 month" logic.</li>
                <li><strong>Accurate (Default):</strong> Uses a <strong>4.35</strong> multiplier to account for the actual number of
                weeks in a year.</li>
              </ul>
            </li>            
          </ul>
        </div>
      </Col>
      <hr />
      {/* Income/Expenses in a Side-by-Side Layout */}
      <Col md={12}>
        <div className="p-3 rounded bg-white text-dark">
          <h3>Income & Expenses</h3>
          <p>This is your primary dashboard. Enter your recurring figures to see your <strong>Remaining Balance.</strong></p>
          <p><strong>How to Enter Data:</strong><br />
          Both sections use the same 4 fields. You only need to enter one amount (Monthly or Weekly); the app will automatically 
          calculate the other.</p>
          <ol>
            <li>
              <strong>Type:</strong> Select a default (e.g., Full-time employment) or type a custom name and press <strong>Enter</strong>.
            </li>
            <li>
              <strong>Company/Entity:</strong> Who the money is coming from or going to.
            </li>
            <li>
              <strong>Amounts:</strong> Enter your Monthly or Weekly figure.            
              <ul>
                <li>Tip: For quarterly or annual items, calculate the monthly average before entering.</li>
              </ul>
            </li>
          </ol>
          <strong>Managing Rows:</strong><br />
          <ul>
            <li>
              Use <strong>(+)</strong> to add a new line and <strong>(-)</strong> to remove one.
            </li>
            <li>
              <strong>Analysis Mode:</strong> If your expenses exceed your income, an analysis screen will automatically appear to 
              help you find balance.
            </li>
          </ul>
          <div className="alert alert-warning">
            <strong>Important:</strong> Changes are not saved automatically. Always click <strong>[Save]</strong> before closing the app.
          </div>
        </div>
      </Col>
    </Row>
    <hr />
    <Row>
    <Col xs={12}>
      <div className="p-3 rounded bg-white text-dark">
        <h2>Debt Management</h2>
        <p>Use the Debt tab to break down balances and apply advanced repayment strategies.</p>
        
        <h4 className="mt-4">Debt List Fields</h4>
        <div className="table-responsive">
          <table className="table table-bordered bg-white">
            <thead className="thead-light">
              <tr>
                <th>Field</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Type</strong></td>
                <td>Select an existing category or type a custom one and press Enter.</td>
              </tr>
              <tr>
                <td><strong>Company</strong></td>
                <td>The original creditor (the bank or person you owe).</td>
              </tr>
              <tr>
                <td><strong>Collector</strong></td>
                <td>Optional field for debts transferred to a third-party agency.</td>
              </tr>
              <tr>
                <td><strong>Amount</strong></td>
                <td>Your total starting debt amount.</td>
              </tr>
              <tr>
                <td><strong>Current Balance</strong></td>
                <td>A calculated field showing the remaining amount after all payments.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h4 className="mt-4">Inline Debt Options (Expand with Arrow)</h4>
        <p>Click the arrow to view more details and calculation inputs:</p>
        
        <div className="p-3 border rounded bg-light mb-3 text-dark">
          <ul className="list-unstyled">
            <li className="mb-3">
              <strong>Manual Mode Inputs:</strong>
              <ol>
                <li><strong>Period (Months/Weeks):</strong> Calculates the required payment based on your deadline.</li>
                <li><strong>Monthly/Weekly Payment:</strong> Calculates how long it will take to pay off based on the amount.</li>
                <li><strong>Status:</strong> Manually set to Not Started, In Progress, Paused, or Completed.</li>
              </ol>
            </li>
            <li className="mb-3">
              <strong>Auto Mode Requirements:</strong>
              <ol>
                <li><strong>APR (%) & Min Payment:</strong> Crucial for <strong>Snowball</strong> or <strong>Avalanche</strong> 
                calculations to work accurately.</li>
              </ol>
            </li>
            <li><strong>Add Payment:</strong> Use this to apply the calculated payment to your history.</li>
            <li>
              <strong>Payment History:</strong>
              <p>Use the arrow <strong>(<Icon.CaretDownSquareFill />)</strong> to expand the history</p>
              <ol>
                <li>View total payments made and remaining schedule.</li>
                <li><strong>Add Transaction:</strong> Log extra charges or fees here to keep the balance current.</li>
                <li><strong>Edit Payments:</strong> Edit the date or payment amount.</li>
              </ol>
            </li>
          </ul>
        </div>
        <div className="alert alert-info">
          <strong>Pro Tip:</strong> Hover over any debt row (or tap on mobile) to see a quick summary without expanding the full details.
        </div>
      </div>
    </Col>
  </Row>
  <hr />
  <Row style={{marginBottom: '15px'}}>
    <Col xs={12}>
      <div className="p-3 rounded bg-white text-dark">
        <h2>Final Pro-Tips</h2>
        <p><strong>Saving Your Progress:</strong> Always click the [Save] button at the bottom of the page before exiting.</p>
        <p><strong>The "Reload" Safety Net:</strong> If you make a mistake and haven't saved yet, click 
        <strong>[Reload Last Save]</strong> to undo all changes made during your current session.</p>
      </div>
    </Col>
  </Row>
  </>
  )
}

export default UserGuide;